import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import { logwebvitals } from 'yoda-site-components/lib/middlewares/WebvitalsMiddleware';
import * as TrackOrderActionTypes from '../actionTypes/TrackOrderActionTypes';
/* eslint-disable import/no-named-as-default */
import TrackOrderActionFilter from '../analytics/TrackOrderActionFilter';
import CancelOrderActionFilter from '../analytics/CancelOrderActionFilter';
import MissingPointsFilter from '../analytics/MissingPointsFilter';
import UpdatePaymentActionFilter from '../analytics/UpdatePaymentActionFilter';

import {
    TRACK_CANCEL_ORDER_SUBMIT_SUCCESS,
    TRACK_CANCEL_ORDER_SLIDER_ON_LOAD_ERROR,
    CANCEL_ORDER_SUBMIT_ERROR,
    TRACK_CANCEL_ORDER_SLIDER_ON_LOAD,
} from '../actionTypes/CancelOrderActionTypes';
import {
    ACCOUNT_TRACK_OPEN_MISSING_MODAL_ERROR,
    ACCOUNT_TRACK_OPEN_MISSING_MODAL_SUCCESS,
} from '../actionTypes/MissingPointsActionsTypes';

import {
    TRACK_UPDATE_PAYMENT_SLIDER_ON_LOAD,
    TRACK_UPDATE_PAYMENT_SUBMIT_SUCCESS,
    TRACK_UPDATE_PAYMENT_SUBMIT_ERROR,
} from '../actionTypes/UpdatePaymentActionTypes';

import { TRACK_MY_LIST_FORM_ERROR, TRACK_MY_LIST_CREATED } from '../actionTypes/MyListActionTypes';

const trackOrderListFilter = new TrackOrderActionFilter();
const cancelOrderFilter = new CancelOrderActionFilter();
const missingPointsFilter = new MissingPointsFilter();
const updatePaymentFilter = new UpdatePaymentActionFilter();
/**
 * This function will used only for redux middleware only to track tagging based on action request
 */
const AccountComponentsMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;

        /**
         * component can trigger an action only for tagging
         * action should contain analytics object as mandatory
         * @param analytics.type - {string}  - tagging key
         * @param analytics.JCPDL - {Object}  - required additional details for tagging event
         */
        try {
            switch (action.type) {
                case TrackOrderActionTypes.ACCOUNT_TRACK_ORDER_ONLOAD:
                    digitalData = trackOrderListFilter.trackOrderPageDL(store, action.payload);
                    analyticsEventName = 'digitalDataReady';
                    logwebvitals(store, digitalData);
                    break;
                /* Cancel order analytics starts */
                // when service success and valid/invalid data
                // then this case
                case TRACK_CANCEL_ORDER_SLIDER_ON_LOAD:
                    digitalData = cancelOrderFilter.cancelOrderSliderDL(store, action.payload);
                    analyticsEventName = 'digitalDataReady';
                    // console.log('Cancel Order Slider On load payload', action.payload);
                    break;

                case CANCEL_ORDER_SUBMIT_ERROR:
                case TRACK_CANCEL_ORDER_SLIDER_ON_LOAD_ERROR:
                    // console.log('Cancel Order API ERROR', 'payload', action.payload);
                    digitalData = cancelOrderFilter.getCancelOrderFormErrorDL(
                        store,
                        action.payload
                    );
                    analyticsEventName = 'formError';
                    break;
                case TRACK_CANCEL_ORDER_SUBMIT_SUCCESS:
                    // console.log('TRACK_CANCEL_ORDER_SUBMIT_SUCCESS: Submit Cancel Order Success', 'payload', action.payload);
                    digitalData = cancelOrderFilter.submitCancelOrderDL(store, action.payload);
                    analyticsEventName = 'orderCancellationTriggerStatus';
                    // eslint-disable-next-line no-console
                    console.log('Track Submit order success:', action.payload);
                    break;
                /* Cancel order analytics ends */
                case ACCOUNT_TRACK_OPEN_MISSING_MODAL_SUCCESS:
                    digitalData = missingPointsFilter.getMissingOpenModalSuccess();
                    analyticsEventName = 'openModal';
                    break;
                case ACCOUNT_TRACK_OPEN_MISSING_MODAL_ERROR:
                    digitalData = missingPointsFilter.getMissingOpenModalError(action.payload);
                    analyticsEventName = 'formError';
                    break;
                /* Payment update nalytics starts */
                case TRACK_UPDATE_PAYMENT_SLIDER_ON_LOAD:
                    digitalData = updatePaymentFilter.updatePaymentSliderDL(store, action.payload);
                    analyticsEventName = 'digitalDataReady';
                    // console.log('Payment update Slider On load payload', action.payload);
                    break;

                case TRACK_UPDATE_PAYMENT_SUBMIT_SUCCESS:
                    digitalData = updatePaymentFilter.submitUpdatePaymentDL(store, action.payload);
                    analyticsEventName = 'paymentUpdateSuccess';
                    // console.log('Track Submit update payment:', action.payload);
                    break;

                case TRACK_UPDATE_PAYMENT_SUBMIT_ERROR:
                    digitalData = updatePaymentFilter.getUpdatePaymentFormErrorDL(
                        store,
                        action.payload
                    );
                    analyticsEventName = 'formError';
                    // console.log('Track update payment error:', action.payload);
                    break;
                /* istanbul ignore next */
                case TRACK_MY_LIST_CREATED:
                    digitalData = {};
                    analyticsEventName = 'createNewList';
                    break;
                /* istanbul ignore next */
                case TRACK_MY_LIST_FORM_ERROR:
                    digitalData = {
                        error: action.payload,
                    };
                    analyticsEventName = 'formError';
                    break;
                /* Payment update analytics ends */
                default:
                    break;
            }
            if (analyticsEventName || digitalData) {
                digitalData.dataVersion = 1;
                analytics.track(analyticsEventName, digitalData);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }
    if (action.type) {
        return next(action);
    }
};
export default AccountComponentsMiddleware;
